import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "volledig scherm uitschakelen"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M8.5 14.2h2.3V21H8.5v-4.5H4v-2.3h4.5zm8 0H21v2.3h-4.5V21h-2.3v-6.8h2.3zm-8-3.4H4V8.5h4.5V4h2.3v6.8H8.5zm8-2.3H21v2.3h-6.8V4h2.3v4.5z"
})));